import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PlayerLayoutComponent } from './player-layout.component';
import { AuthGuard } from 'src/app/core/guards/auth.guard';
import { FeatureGuard } from 'src/app/core/guards/feature.guard';

const routes: Routes = [
  {
    path: 'player',
    redirectTo: '/player/store',
    pathMatch: 'full',
  },
  {
    path: 'player',
    component: PlayerLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'store',
        canActivate: [FeatureGuard],
        data: { featureFlag: 'store' },
        loadChildren: () =>
          import('./store/store.module').then((m) => m.StoreModule),
      },
      {
        path: 'library',
        canActivate: [FeatureGuard],
        data: { featureFlag: 'library' },
        loadChildren: () =>
          import('./game-library/game-library.module').then((m) => m.GameLibraryModule),
      },
      {
        path: 'social',
        canActivate: [FeatureGuard],
        data: { featureFlag: 'social' },
        loadChildren: () =>
          import('./social/social.module').then((m) => m.SocialModule),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PlayerLayoutRoutingModule {}
